/**
 * Module dependencies.
 */

import { CatalogCategories } from 'components/molecules/catalog-categories/catalog-categories';
import { CatalogHeader } from 'components/molecules/catalog-header/catalog-header';
import { CatalogIntroduction } from 'components/molecules/catalog-introduction/catalog-introduction';
import { CategoryIntroduction } from 'components/molecules/category-introduction/category-introduction';
import { CategoryProducts } from 'components/molecules/category-products/category-products';
import { Footer } from 'components/molecules/footer/footer';
import { ImageCatalog, ImageWrapper } from './catalog.style';
import { JSX } from 'react';
import { ProductDescription } from 'components/molecules/product-description/product-description';
import { ProductInformation } from 'components/molecules/product-information/product-information';
import { useResolveCatalog } from 'components/hooks/use-resolve-catalog';

/**
 * `Props` type.
 */

type Props = {
  catalogCategories: any;
  paths: string[];
  socialNetworks: any;
};

/**
 * Export `Resolve` component.
 */

function Resolve(props: Props): JSX.Element | null {
  const { catalogCategories, paths } = props;
  const { category, product, subCategory } = useResolveCatalog(
    catalogCategories,
    paths,
  );

  if (!catalogCategories) {
    return null;
  }

  if (product && subCategory && category) {
    return (
      <>
        <ProductInformation product={product} />

        <ProductDescription
          catalogCategories={catalogCategories}
          product={product}
        />
      </>
    );
  }

  if (category) {
    return (
      <>
        <CategoryIntroduction category={category} />

        <CategoryProducts category={category} />
      </>
    );
  }

  return (
    <>
      <CatalogIntroduction />

      <ImageWrapper>
        <ImageCatalog src={'/indalsu.png'} />
      </ImageWrapper>

      <CatalogCategories catalogCategories={catalogCategories} />
    </>
  );
}

/**
 * Export `Catalog` component.
 */

export function Catalog(props: Props): JSX.Element {
  return (
    <>
      <CatalogHeader />

      <Resolve {...props} />

      <Footer socialNetworks={props.socialNetworks} />
    </>
  );
}
